export default {
    label: 'Explanation',
    clientService: 'Preferred by the client',
    slotService: 'Online ordering',
    normalService: 'Service'
}
